import React, { useState, useEffect } from "react";
import { Collapse } from "antd";
import TourInformationForm from "../../pages/EditForm/TourInformationForm";
import "./sectionForms.css";

const { Panel } = Collapse;

interface TourInformationSectionProps {
    form: any;
    initialValues?: any;
    tiaData?: any;
}

const config = {
    rules: [
        {
            required: true,
            message: "此項為必填。",
        },
    ],
};

export default function TourInformationSection({ form, initialValues, tiaData }: TourInformationSectionProps) {
    const [firstDay, setFirstDay] = useState<any>(null);
    const [lastDay, setLastDay] = useState<any>(null);
    const [errorArrivalDate, setErrorArrivalDate] = useState(null);
    const [errorDepatureDate, setErrorDepatureDate] = useState(null);
    const [otherArrivalControlPoint, setOtherArrivalControlPoint] = useState(false);
    const [otherDepatureControlPoint, setOtherDepatureControlPoint] = useState(false);
    const [hasTravelAgent, setHasTravelAgent] = useState(null);

    const currencyList = tiaData?.currencyList || ["HKD", "RMB", "USD"];
    const chinaCityList = tiaData?.chinaCityList?.map((data: any) => ({
        label: data.province,
        value: data.province,
        children: data.cities.map((city: string) => ({
            label: city,
            value: city,
        })),
    })) || [];
    const travelAgentList = tiaData?.typeOfTravelAgentList || ["內地旅行代理商", "內地非旅行代理商單位"];
    const controlPointList = tiaData?.controlPointList || ["羅湖", "落馬洲", "紅磡", "其他"];

    return (
        <Collapse defaultActiveKey={["1"]}>
            <Panel header={<h3>第 II 部分：內地入境旅行團資料</h3>} key="1" forceRender>
                <div className="booking-section">
                    <TourInformationForm
                        form={form}
                        config={config}
                        errorArrivalDate={errorArrivalDate}
                        setErrorArrivalDate={setErrorArrivalDate}
                        currencyList={currencyList}
                        chinaCityList={chinaCityList}
                        travelAgentList={travelAgentList}
                        firstDay={firstDay}
                        setFirstDay={setFirstDay}
                        lastDay={lastDay}
                        setLastDay={setLastDay}
                        errorDepatureDate={errorDepatureDate}
                        setErrorDepatureDate={setErrorDepatureDate}
                        otherDepatureControlPoint={otherDepatureControlPoint}
                        setOtherDepatureControlPoint={setOtherDepatureControlPoint}
                        hasTravelAgent={hasTravelAgent}
                        setHasTravelAgent={setHasTravelAgent}
                        controlPointList={controlPointList}
                        otherArrivalControlPoint={otherArrivalControlPoint}
                        setOtherArrivalControlPoint={setOtherArrivalControlPoint}
                    />
                </div>
            </Panel>
        </Collapse>
    );
}
